import find from 'lodash/find';

export type CustomerChannelType = {
  id: string;
  shortHumanReadable: string;
  url: string;
};

export const Selling: CustomerChannelType = {
  id: 'selling',
  url: 'for-sale',
  shortHumanReadable: "I'm selling",
};

export const Leasing: CustomerChannelType = {
  id: 'leasing',
  url: 'for-lease',
  shortHumanReadable: "I'm leasing",
};

export const customerChannelsObjects = { Selling, Leasing };

export const customerChannelsArray = [Selling, Leasing];

class ChannelNotFound extends Error {
  constructor(channel: string) {
    super();
    this.message = `the channel '${channel}' was not found`;
  }
}

export function parseCustomerUrlChannel(urlChannel: string) {
  const channelObject = find(customerChannelsArray, (ch) => ch.url === urlChannel);
  if (channelObject) {
    return channelObject;
  }
  throw new ChannelNotFound(urlChannel);
}
